class InputCheck {
	/**
	 * 日付フォーマットをチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} フォーマットチェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationDate(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// 日付フォーマットチェック
		if (!ckstr.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
			return false;
		}
		const vYear: number = parseInt(ckstr.substr(0, 4), 10) - 0;
		const vMonth: number = parseInt(ckstr.substr(5, 2), 10) - 1;
		const vDay: number = parseInt(ckstr.substr(8, 2), 10) - 0;

		if (
			vYear <= 2999 &&
			vMonth >= 0 &&
			vMonth <= 11 &&
			vDay >= 1 &&
			vDay <= 31
		) {
			const vDt = new Date(vYear, vMonth, vDay);
			if (!vDt) {
				return false;
			} else if (
				vDt.getFullYear() === vYear &&
				vDt.getMonth() === vMonth &&
				vDt.getDate() === vDay
			) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	/**
	 * 時刻フォーマットをチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} フォーマットチェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationTime(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// 時刻フォーマットチェック
		if (!ckstr.match(/^\d{2}\:\d{2}$/)) {
			return false;
		}
		const vHour: number = parseInt(ckstr.substr(0, 2), 10) - 0;
		const vMinutes: number = parseInt(ckstr.substr(3, 2), 10) - 0;

		if (vHour >= 0 && vHour <= 23 && vMinutes >= 0 && vMinutes <= 59) {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * 電話・FAX番号の文字種（ハイフンのみ）をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 文字種チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationTelNoHyphen(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// ハイフンのみチェック
		if (ckstr.match(/^[-]+$/)) {
			return false;
		}
		return true;
	}

	/**
	 * 電話・FAX番号の文字種（半角数字＋ハイフン）をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 文字種チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationTelNoChar(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// 半角数値とハイフンチェック
		if (ckstr.match(/[^\d-]/)) {
			return false;
		}
		return true;
	}

	/**
	 * 文字種（半角数字）をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 文字種チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationIsNumber(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// 文字種（半角数字）チェック
		if (ckstr.match(/[^\d]+/)) {
			return false;
		}
		return true;
	}

	/**
	 * 文字種（半角英数字+"."+"-"+"_"）をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 文字種チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationIsAlphabetNumber(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// 文字種（半角英数字）チェック
		if (ckstr.match(/[^\d\w\-\.]+/)) {
			return false;
		}
		return true;
	}

	/**
	 * メールアドレスフォーマットをチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} フォーマットチェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationEMail(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// 以下の形式になっていることをチェックする。
		//
		// 		（許容文字で構成された文字列）@（許容文字で構成された文字列）
		//
		// 	なお、許容文字は以下
		// 	「0～9」
		// 	「a～z」
		// 	「A～Z」
		// 	「_」「-」「.」「!」「#」「$」「%」「&」「'」「*」「+」「/」「=」「?」「^」「`」「{」「|」「}」
		//
		// 	備考
		// 		チェック内容は精密にRFCのメールアドレスの規約に沿ったチェックするものではなく、Redmine#2139、8187でシステム内部で統一すると
		// 		決めたものをチェックしている。
		// 		（厳密なRFCの決まりより緩い制限であるが、メールアドレス自体が外部システムに登録された外部の情報の為、Generalistで複雑な形式チェックをする意味は無い）
		//
		if (
			!ckstr.match(
				/^[\da-zA-Z][\d\w_\-.!#$%&'\*\+/=\?\^`{|}]+@[\da-zA-Z][\d\w_\-.!#$%&'\*\+/=\?\^`{|}]+$/
			)
		) {
			return false;
		}
		return true;
	}

	/**
	 * メールアドレス使用可能文字をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 使用可能文字チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationEMailChar(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		// メールアドレス使用可能文字チェック
		if (ckstr.match(/[^\d\w\-\.\@]+/)) {
			return false;
		}
		return true;
	}

	/**
	 * 文字種（半角カナ）をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 文字種チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationHalfSizeKana(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		let res: boolean = false;
		// 半角カタカナ マッチする正規表現オブジェクト作成
		const regStr: string = '[\uFF66-\uFF9F]';

		const regObj: RegExp = new RegExp(regStr);

		for (let i: number = 0; i < ckstr.length; i++) {
			res = regObj.test(ckstr.charAt(i));
			if (res === false) {
				return false;
			}
		}

		return true;
	}

	/**
	 * 文字種（全半角カナ）をチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} 文字種チェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationKana(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		for (let i = 0; i < ckstr.length; i++) {
			const c = escape(ckstr.charAt(i));

			if (
				!(c >= '%u30A1' && c <= '%u30FC') &&
				!(c >= '%uFF66' && c <= '%uFF9E') &&
				!(c === '%20') &&
				!(c === '%u3000')
			) {
				return false;
			}
		}

		return true;
	}

	/**
	 * 郵便番号フォーマットをチェックします。
	 *
	 * @param {String}
	 *            ckstr チェック対象文字列
	 *
	 * @return {Boolean} フォーマットチェック結果
	 *
	 * @example <CAPTION>利用方法</CAPTION>
	 *
	 * <PRE>
	 * </PRE>
	 */
	public static validationPostCode(ckstr: string): boolean {
		if (ckstr.length === 0) {
			return true;
		}

		if (
			ckstr.match(/^[\d]{3}-[\d]{4}$/) ||
			ckstr.match(/^[\d]{3}-[\d]{2}$/)
		) {
			return true;
		}

		if (
			!ckstr.match(/^[\d]{7}$/) &&
			!ckstr.match(/^[\d]{5}$/) &&
			!ckstr.match(/^[\d]{3}$/)
		) {
			return false;
		}

		return true;
	}

	// /**
	//  * 禁則文字チェックをチェックします。
	//  *
	//  * @param {String}
	//  *            ckstr チェック対象文字列
	//  *
	//  * @return {Boolean} 使用可能文字チェック結果
	//  *
	//  * @example <CAPTION>利用方法</CAPTION>
	//  *
	//  * <PRE>
	//  * </PRE>
	//  */
	// validationProhibitedInput(ckstr: string): boolean {
	// 	if (ckstr.length === 0) {
	// 		return true;
	//     }

	// 	// TODO 現状禁則文字の指定がないため、ノーチェック。
	// 	return true;
	// },

	// /**
	//  * リストデータの必須チェックを行います。
	//  *
	//  * @param {String}
	//  *            ckstr チェック対象文字列
	//  *
	//  * @return {Boolean} チェック結果
	//  *
	//  * @example <CAPTION>利用方法</CAPTION>
	//  *
	//  * <PRE>
	//  * </PRE>
	//  */
	// validationRequiredList(ckstr: string): boolean {
	// 	const check = true;

	// 	if ($.isArray(ckstr)) {
	// 		const list = $.grep(ckstr, function (e) {
	// 			return e !== "";
	// 		});
	// 		if (list.length === 0) {
	// 			check = false;
	// 		}
	// 		;
	// 	} else {
	// 		if (ckstr.length === 0) {
	// 			check = false;
	// 		}
	// 	}

	// 	return check;
	// },

	/**
	 * 数値チェック（数値入力か、またはブランクかをチェックする）
	 *
	 * @param {String}
	 *            targetString チェック対象数値文字列
	 * @return {boolean} true：エラー false：正常
	 */
	public static IsNumberOrBlank(targetString?: string): boolean {
		// データが存在する場合（ブランクは許容する）
		if (targetString && targetString.length !== 0) {
			// 通常の数値チェック
			if (!this.validationIsNumber(targetString)) {
				return false;
			}
		}

		return true;
	}

	/**
	 * 小数点付き数値チェック（小数点付き数値入力か、またはブランクかをチェックする）
	 * ※許容するのは桁数3桁、小数点以下一桁
	 * @param {String}
	 *            targetString チェック対象数値文字列
	 * @return {boolean} true：エラー false：正常
	 */
	public static IsNumericOrBlank(targetString: string): boolean {
		// データが存在する場合（ブランクは許容する）
		if (targetString && targetString.length !== 0) {
			// 文字種（半角数字とコロン1個）チェック
			if (!targetString.match(/^[0-9]{1,2}(\.[0-9])?$/)) {
				return false;
			}
		}

		return true;
	}

	/**
	 * 入力日時の妥当性チェック 「YYYY/MM/DD hh:mm」形式で入力されているか？有りえない日時でないかをチェックします。
	 *
	 * @param {String}
	 *            targetDateTime チェック対象日時文字列
	 * @return {boolean} true：エラー false：正常
	 */
	public static chkErYYYYMMDDhhmm(targetDateTime: string): boolean {
		// データ存在チェック
		if (targetDateTime.length === 0) {
			// 形式チェックであり、必須チェックではないので正常応答
			return false;
		}

		// 日付と時刻の分解
		const splitDateTime = targetDateTime.split(' ');

		// 分割後の日付、時刻のいずれかが無ければエラー
		if (!splitDateTime[0] || !splitDateTime[1]) {
			return true;
		}

		// 日付フォーマットチェック（YYYY/MM/DD）
		if (!this.validationDate(splitDateTime[0])) {
			// 日付形式エラー
			return true;
		}

		// 時刻フォーマットチェック（hh:mm）
		if (!this.validationTime(splitDateTime[1])) {
			// 時刻形式エラー
			return true;
		}

		return false;
	}

	/**
	 * 入力日時の過去未来判定 「YYYY/MM/DD hh:mm」形式で入力された日付を比較して大小判定を行い返却します。
	 * 前提として形式チェック、データ存在チェックは終わっているものとします。
	 *
	 * @param {String}
	 *            targetDateTime1 比較対象日時文字列
	 * @param {String}
	 *            targetDateTime2 比較対象日時文字列
	 *
	 * @return {number} 比較結果
	 */
	public static chkFuturePast(
		targetDateTime1: string,
		targetDateTime2: string
	): number {
		// 比較元日時のセット
		const chkTargDate1 = new Date(targetDateTime1 + ':00');

		// 比較先日時のセット
		const chkTargDate2 = new Date(targetDateTime2 + ':00');

		// 前後関係チェック
		if (chkTargDate1.getTime() < chkTargDate2.getTime()) {
			return -1;
		} else if (chkTargDate1.getTime() === chkTargDate2.getTime()) {
			return 0;
		} else {
			return 1;
		}
	}

	/**
	 * エラーメッセージ生成関数 対象カラム名リストを受け取り 「item名」、「item名」はXXXです。形式の対象カラム文字列を生成する。
	 *
	 * @param {Array}
	 *            colList 対象カラム文字列
	 *
	 * @return {String} エラーメッセージ文字列
	 */
	public static makeErrColListString(colList: string[]): string {
		let errColListString = '';

		// データ数分ループ
		for (let i = 0; i < colList.length; i++) {
			errColListString += '「' + colList[i] + '」';

			// 最終データ以外の場合は「、」を連結
			if (i < colList.length - 1) {
				// 「、」を連結
				errColListString += '、';
			}
		}

		return errColListString;
	}

	/**
	 * INT型数値最大値チェック
	 *
	 * @param {String}
	 *            targetString チェック対象数値文字列（数値型チェックは終わっている前提とする。マイナスは考慮しない）
	 * @return {boolean} true：エラー false：正常
	 */
	public static IsIntLessMaxOrBlank(targetString?: string): boolean {
		// データが存在する場合（ブランクは許容する）
		if (targetString && targetString.length !== 0) {
			// SQLServerのカラムタイプintの最大値を超えたか判定
			if (2147483647 < parseInt(targetString, 10)) {
				return false;
			}
		}

		return true;
	}

	/**
	 * 文字列最大サイズチェック
	 *
	 * @param {String} targetString チェック対象数値文字列
	 * @param {int} maxSize 最大値（同値は正常）
	 * @return {boolean} true：エラー false：正常
	 */
	public static chkStringMaxLength(
		targetString: string,
		maxSize: number
	): boolean {
		// データが存在する場合（ブランクは許容する）
		if (targetString && targetString.length !== 0) {
			// 文字列サイズが指定の最大値を超えたかチェック
			if (maxSize < targetString.length) {
				return true;
			}
		}

		return false;
	}

	/**
	 * 日付データ変換処理（YYYY-MM-DDTHH24:MIからYYYY/MM/DD HH24:MI）
	 */
	public static convertDate(datestr: string): string {
		if (datestr && datestr.length !== 0) {
			datestr = datestr.replace(/\-/g, '/');
			datestr = datestr.replace('T', ' ');
		}
		return datestr;
	}

	/**
	 * 日付データ変換処理（YYYY/MM/DD HH24:MIからYYYY-MM-DDTHH24:MI）
	 */
	public static reconvertDate(datestr: string): string {
		if (datestr && datestr.length !== 0) {
			datestr = datestr.replace(/\//g, '-');
			datestr = datestr.replace(' ', 'T');
		}
		return datestr;
	}

	/**
	 * 文字列有無判定処理（空白は許可）
	 * @param str 判定文字列
	 */
	public static isBlank(str?: string): boolean {
		if (str == null) {
			str = '';
		}
		return /^\s*$/.test(str);
	}
}

export default InputCheck;



// WEBPACK FOOTER //
// ./src/utils/InputCheck.ts